// Seletor de arquivo das telas de importação de roteiros. Fica desabilitado enquanto há requisição em andamento:
// trocar o arquivo durante a prévia ou a confirmação deixava a resposta de um arquivo valendo para outro (P3-WR-03).
import type { ChangeEvent, ReactElement } from 'react';

interface SeletorArquivoProps {
  readonly aceita: string;
  readonly rotulo: string;
  readonly desabilitado: boolean;
  readonly onEscolher: (arquivo: File | null) => void;
}

export function SeletorArquivo({ aceita, rotulo, desabilitado, onEscolher }: SeletorArquivoProps): ReactElement {
  return (
    <input
      type="file"
      accept={aceita}
      aria-label={rotulo}
      disabled={desabilitado}
      onChange={(evento: ChangeEvent<HTMLInputElement>) => onEscolher(evento.target.files?.[0] ?? null)}
    />
  );
}
